import getPartner from '@/concepts/Account/repository/getPartner'
import { PartnerDataProps } from '@/concepts/Account/types/Partner'
import { useEffect, useState } from 'react'

const usePartner = () => {
  const [partner, setPartner] = useState<
    PartnerDataProps['partner'] | undefined
  >()

  useEffect(() => {
    const fetchPartner = async () => {
      const response = await getPartner()
      if ('error' in response) {
        console.error('Error fetching partner:', response.error)
        return
      }

      setPartner(response.partner)
    }

    fetchPartner()
  }, [])

  return { partner }
}

export { usePartner }
